import Cookies from "js-cookie";

export class cookieBar {
  private element: HTMLElement;
  private accept: HTMLButtonElement | null;

  constructor(element: HTMLElement) {
    if (element) {
      this.element = element;
      this.accept = this.element.querySelector(".privacy-consent__accept");
      this.init();
    }
  }

  private init() {
    if (Cookies.get("__id5_cookie_privacy") === undefined) {
      this.element.removeAttribute("hidden");
    } else {
      this.element.remove();
    }
    this.accept?.addEventListener("click", () => {
      this.element.classList.add("fade-out");
      Cookies.set("__id5_cookie_privacy", "true"); // Change the name of this variable on a new site
      setTimeout(() => {
        this.element.remove();
      }, 300);
    });
  }
}

export default function cookieBarInit() {
  const cb = document.querySelectorAll(
    ".privacy-consent"
  ) as NodeListOf<HTMLElement>;
  if (cb.length > 0) {
    for (let i = 0; i < cb.length; i++) {
      new cookieBar(cb[i]);
    }
  }
}
